import { FormEvent, useCallback, useState } from 'react';
import { useSaveTrackingForecastPreferenceMutation } from 'services/api/Meteorology/Fields/TrackingForecast/DetailedView';
import { selectCPMFTrackingForecastSubpage } from 'redux/reducers/meteorologyFieldsTrackingForecastControlPanelReducer';
import { useSelector } from 'react-redux';
import { ResponseError } from 'services/api/base';
import usePreferenceParams from './usePreferenceParams';

export default function useSavePreference() {
  const [savePreferenceTrigger, { isLoading }] = useSaveTrackingForecastPreferenceMutation();
  const preferenceParams = usePreferenceParams();
  const subpage = useSelector(selectCPMFTrackingForecastSubpage);
  const [showFormModal, setShowFormModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [name, setName] = useState('');
  const valid = Boolean(name);
  const disabled = preferenceParams === undefined;

  const handleSubmit = useCallback(async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (!preferenceParams) return;

    const response = await savePreferenceTrigger({
      name,
      subpage,
      preferenceParams,
    });

    if ('error' in response) {
      setErrorMessage((response.error as ResponseError).data);
      setShowErrorModal(true);
    } else {
      setName('');
      setShowConfirmationModal(true);
    }
    setShowFormModal(false);
  }, [preferenceParams, name, savePreferenceTrigger, subpage]);

  const onNameChange = useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setName(event.target.value);
  }, []);

  return {
    showFormModal,
    setShowFormModal,
    showConfirmationModal,
    setShowConfirmationModal,
    showErrorModal,
    setShowErrorModal,
    errorMessage,
    setErrorMessage,
    onNameChange,
    valid,
    handleSubmit,
    isLoading,
    disabled,
  };
}
